import { apiRequest } from '../api/client';

/**
 * Claims any Route42 tenant invitations that belong to the signed-in Cognito
 * identity. The endpoint is intentionally safe to call for already-active
 * members as well, which makes it useful on both first activation and later
 * sessions.
 */
export function isIgnorableMembershipActivationError(error: unknown): boolean {
  return Boolean(
    error
      && typeof error === 'object'
      && 'code' in error
      && (error as { code?: unknown }).code === 'NO_PENDING_INVITATION',
  );
}

export async function activateRoute42Memberships(): Promise<void> {
  try {
    await apiRequest('/v1/auth/memberships/activate', {
      method: 'POST',
      body: JSON.stringify({}),
      customerScoped: false,
    });
  } catch (error) {
    // A Cognito identity may exist before it has been invited into Route42.
    // That is not an authentication failure, so allow the normal profile load
    // to decide what workspace, if any, is available.
    if (isIgnorableMembershipActivationError(error)) return;
    throw error;
  }
}
